import { supabase } from '../lib/supabase';

export const getBranding = async (companyId) => {
  const { data, error } = await supabase?.from('company_branding')?.select('*')?.eq('company_id', companyId)?.maybeSingle();
  if (error) throw error;
  return data;
};

export const saveBranding = async (companyId, brandingData) => {
  const payload = {
    ...brandingData,
    company_id: companyId,
    updated_at: new Date()?.toISOString(),
  };

  const { data, error } = await supabase?.from('company_branding')?.upsert(payload, { onConflict: 'company_id' })?.select()?.single();
  if (error) throw error;
  return data;
};

export const uploadLogo = async (companyId, file) => {
  const ext = file?.name?.split('.')?.pop();
  const ts = Date.now();
  const path = `${companyId}/logo_${ts}.${ext}`;

  const { error: uploadError } = await supabase?.storage
    ?.from('company-assets')
    ?.upload(path, file, { upsert: true, contentType: file?.type });

  if (uploadError) throw uploadError;

  const { data } = supabase?.storage?.from('company-assets')?.getPublicUrl(path);
  if (!data?.publicUrl) throw new Error('No se pudo obtener la URL pública del logotipo.');
  return data?.publicUrl;
};

export const uploadHeaderImage = async (companyId, file) => {
  const ext = file?.name?.split('.')?.pop();
  const ts = Date.now();
  const path = `${companyId}/header_${ts}.${ext}`;

  const { error: uploadError } = await supabase?.storage
    ?.from('company-assets')
    ?.upload(path, file, { upsert: true, contentType: file?.type });

  if (uploadError) throw uploadError;

  const { data } = supabase?.storage?.from('company-assets')?.getPublicUrl(path);
  if (!data?.publicUrl) throw new Error('No se pudo obtener la URL pública de la imagen de cabecera.');
  return data?.publicUrl;
};

export const uploadLetterhead = async (companyId, file) => {
  const ext = file?.name?.split('.')?.pop();
  const ts = Date.now();
  const path = `${companyId}/letterhead_${ts}.${ext}`;

  const { error: uploadError } = await supabase?.storage
    ?.from('company-assets')
    ?.upload(path, file, { upsert: true, contentType: file?.type });

  if (uploadError) throw uploadError;

  const { data } = supabase?.storage?.from('company-assets')?.getPublicUrl(path);
  if (!data?.publicUrl) throw new Error('No se pudo obtener la URL pública de la hoja membretada.');
  return data?.publicUrl;
};

export const uploadBusinessCard = async (companyId, file) => {
  const ext = file?.name?.split('.')?.pop();
  const ts = Date.now();
  const path = `${companyId}/business_card_${ts}.${ext}`;

  const { error: uploadError } = await supabase?.storage
    ?.from('company-assets')
    ?.upload(path, file, { upsert: true, contentType: file?.type });

  if (uploadError) throw uploadError;

  const { data } = supabase?.storage?.from('company-assets')?.getPublicUrl(path);
  if (!data?.publicUrl) throw new Error('No se pudo obtener la URL pública de la tarjeta de presentación.');
  return data?.publicUrl;
};

/**
 * Returns true if the company has uploaded custom papelería (letterhead).
 * When true, document generators must use the uploaded file as the design base.
 */
export const hasCustomPapeleria = (branding) => {
  return !!(branding?.letterhead_url || branding?.has_custom_papeleria);
};

/**
 * Returns the effective document template config for a company.
 * Priority: custom letterhead > selected_proposal > default generated layout
 */
export const getDocumentTemplate = (branding) => {
  if (!branding) return { type: 'default', branding: {} };

  if (branding?.letterhead_url) {
    return { type: 'custom_letterhead', branding };
  }

  if (branding?.selected_proposal && branding?.selected_proposal !== 'none') {
    return { type: 'proposal', proposal: branding?.selected_proposal, branding };
  }

  return { type: 'generated', branding };
};
